import {Box, Dialog, DialogContent, DialogTitle, Grid, Typography} from "@mui/material";
import {useParams} from "react-router-dom";
import {useQueryCoordinate} from "../../clients/graphql/graphql.hooks";
import {styled, useTheme} from "@mui/material/styles";
import PortfolioCrudPanelREDESIGN from "../../views/portfolios/PortfolioCrudPanel";
import UserHistoricalValueChart from "../../components/tables/UserHistoricalValueChart";
import {PortfolioPositionsTable} from "../../components/tables/PortfolioPositionsTable";
import {yodaWhoisit} from "../../clients/graphql/pages/users-queries";
import {PopularAssetsList} from "../assets/PopularAssetsList";
import React, {useEffect, useState} from "react";
import Button from "@mui/material/Button";

export default function YodaPage() {

    const theme = useTheme();
    const { portfolioKey } = useParams();
    const intPortfolioKey = parseInt(portfolioKey as string);
    const [open, setOpen] = useState(false);

    const { data, loading, error } = useQueryCoordinate(yodaWhoisit, { variables: { portfolioKey: intPortfolioKey } });

    useEffect(() => {
        if (data && data?.whoisit?.institution?.institutionName !== 'YODA') {
            setOpen(true);
        }
    }, [data]);

    const Item = styled(Box)(() => ({
        border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.15)' : '1px solid rgba(18, 18, 18, 0.15)',
        borderRadius: '5px',
        marginTop: 10,
    }));

    if (loading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>Error fetching data. Please reload page</div>;
    }

    const userKey = data?.whoisit?.user?.userKey;
    const institutionKey = data?.whoisit?.institution?.institutionKey;

    const parsedUserKey = parseInt(userKey as string);
    const parsedInstitutionKey = parseInt(institutionKey as string);

    if (data?.whoisit?.institution?.institutionName === 'YODA') {
        return (
            <Box>
                <Box sx={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                    <Box
                        component="img"
                        src="/yoda.png"
                        alt="Yoda"
                        sx={{width: '5rem', height: '5rem'}}
                    />
                    <Typography variant="h4" sx={{color: 'grey'}}>
                        #{portfolioKey}
                    </Typography>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={2.5}>
                        <Item>
                            <PortfolioCrudPanelREDESIGN portfolioKey={intPortfolioKey} userKey={userKey}
                                                        deletedAt={data?.whoisit?.user?.deletedAt}/>
                        </Item>
                    </Grid>
                    <Grid item xs={4.5}>
                        <Item sx={{height: '33rem'}}>
                            <UserHistoricalValueChart portfolioKey={intPortfolioKey}/>
                        </Item>
                    </Grid>
                    <Grid item xs={2}>
                        <Item sx={{height: '33rem'}}>
                            <PopularAssetsList info={{userKey: parsedUserKey, institutionKey: parsedInstitutionKey}}/>
                        </Item>
                    </Grid>
                    <Grid item xs={7}>
                        <Item>
                            <PortfolioPositionsTable userKey={parsedUserKey} portfolioKey={intPortfolioKey}/>
                        </Item>
                    </Grid>
                </Grid>
            </Box>
        )
    } else {
        return (
            <Dialog open={open} onClose={() => {}} disableEscapeKeyDown>
                <DialogTitle><Typography>Jedi only! The force Robinhood knows not...</Typography></DialogTitle>
                <DialogContent>
                    <Typography sx={{fontSize: 'small'}}>i.e. this page is only for Yoda's lol</Typography>
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant="contained" onClick={() => window.location.href = `/users/${parsedUserKey}`}>
                            Back to user
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        );
    }
}
